module.exports = __webpack_public_path__ + "static/logo-aion-f5590063e243cd0f4f4054f4d1104b8d.png";